export default function Terms() {
  return (
    <div data-testid="terms-page" className="container-pad py-20 max-w-3xl">
      <div className="overline">Legal</div>
      <h1 className="font-display text-5xl text-navy mt-4 tracking-tight">Terms of Service</h1>
      <p className="text-muted2 mt-3 text-sm">Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long" })}</p>

      <div className="prose prose-neutral max-w-none mt-10 space-y-6 text-ink leading-relaxed">
        <p>
          These Terms govern your use of the Elevate Consulting website and services. By using this site, you agree to
          these Terms.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">1. Services</h2>
        <p>
          Elevate Consulting Pty Ltd provides NDIS registration and compliance consulting services to providers in
          Australia. Specific deliverables and timelines are agreed in writing via a separate service agreement.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">2. Content</h2>
        <p>
          All content on this site is provided for general information and does not constitute legal, financial, or
          regulatory advice. Engagement of our consultants is required for tailored advice.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">3. Intellectual property</h2>
        <p>
          All site content, including text, graphics, logos, and downloadable guides, is the property of Elevate
          Consulting Pty Ltd unless otherwise stated. You may not reproduce or redistribute content without permission.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">4. Client portal</h2>
        <p>
          Access to the client portal is provided to engaged clients only. You are responsible for maintaining the
          confidentiality of your account credentials and for all activity that occurs under your account.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">5. Liability</h2>
        <p>
          To the maximum extent permitted by Australian law, Elevate Consulting is not liable for any indirect or
          consequential loss arising from use of this site or our services.
        </p>

        <h2 className="font-display text-2xl text-navy mt-10">6. Governing law</h2>
        <p>
          These Terms are governed by the laws of New South Wales, Australia. Any disputes will be subject to the
          exclusive jurisdiction of the NSW courts.
        </p>

        <p className="text-sm text-muted2 mt-10">
          Questions about these Terms? Contact us at <a href="mailto:Jordan@elevateconsultingau.com" className="text-ochre underline">Jordan@elevateconsultingau.com</a>.
        </p>
      </div>
    </div>
  );
}
